import { Injectable } from '@angular/core';
import { Empregador, Funcionario } from '../api.service';
import { ServicoFormatacao } from './servico-formatacao';

@Injectable({ providedIn: 'root' })
export class ServicoBuscaCadastro {
  constructor(private readonly servicoFormatacao: ServicoFormatacao) {}

  filtrarEmpregadores(empregadores: Empregador[], termoBusca: string, empregadorSelecionado: string) {
    const termo = this.servicoFormatacao.normalizarBusca(termoBusca);
    if (termo.length < 3) {
      return [];
    }

    const selecionado = empregadores.find(item => item.id === empregadorSelecionado);
    if (selecionado && termo === this.servicoFormatacao.normalizarBusca(selecionado.razaoSocial)) {
      return [];
    }

    return empregadores.filter(item =>
      this.servicoFormatacao
        .normalizarBusca(`${item.razaoSocial} ${item.nomeFantasia || ''} ${item.documento || ''}`)
        .includes(termo)
    );
  }

  listarEmpregadoresModal(empregadores: Empregador[], termoBusca: string) {
    const termo = termoBusca.trim();
    if (termo.length < 3) {
      return empregadores;
    }
    return this.filtrarEmpregadores(empregadores, termo, '');
  }

  filtrarFuncionarios(funcionarios: Funcionario[], termoBusca: string, funcionarioSelecionado: string) {
    const termo = this.servicoFormatacao.normalizarBusca(termoBusca);
    if (termo.length < 3) {
      return [];
    }

    const selecionado = funcionarios.find(item => item.id === funcionarioSelecionado);
    if (selecionado && termo === this.servicoFormatacao.normalizarBusca(this.rotuloFuncionario(selecionado))) {
      return [];
    }

    return funcionarios.filter(item =>
      this.servicoFormatacao
        .normalizarBusca(`${item.nome} ${item.matricula} ${item.cpf} ${this.servicoFormatacao.formatarCpf(item.cpf)}`)
        .includes(termo)
    );
  }

  listarFuncionariosModal(funcionarios: Funcionario[], termoBusca: string) {
    const termo = termoBusca.trim();
    if (termo.length < 3) {
      return funcionarios;
    }
    return this.filtrarFuncionarios(funcionarios, termo, '');
  }

  rotuloEmpregador(item: unknown) {
    return (item as Empregador).razaoSocial || '';
  }

  detalheEmpregador(item: unknown) {
    return (item as Empregador).documento || '';
  }

  rotuloFuncionario(item: unknown) {
    const funcionario = item as Funcionario;
    return `${funcionario.matricula} - ${funcionario.nome}`;
  }

  detalheFuncionario(item: unknown) {
    return this.servicoFormatacao.formatarCpf((item as Funcionario).cpf);
  }
}
